module.exports = __webpack_public_path__ + "static/divyaa-7c859fd7e8d79fdafa595e5aa748df10.jpg";